export const routes = ( prefix ) => [
    {
        path: `/${prefix}/questionaires`,
        name: `${prefix}.questionaires.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.questionaires.index`,
                PageDescription: "Questionaire listing/ Create",
            },
        },
    },
];
